import * as React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useMutation, useQuery } from '@apollo/client/react'
// graphql
import { PARENT_PLAN_SHORT_DETAILS_TREE_QUERY } from 'graphql/plan/queries'
import {
  PLAN_ITEM_CREATE_MUTATION,
  PLAN_ITEM_DELETE_MUTATION,
  PLAN_TREE_UPDATE_MUTATION
} from 'graphql/plan/mutations'
// types
import { IPlanItem } from 'types/graphql'
import { MutationFn } from 'types/apollo'
import { NCreatePlanItem, NDeletePlanItem } from 'types/plan/helpers'
// utils
import get from 'lodash/get'

export declare namespace NObjectivesListAPI {
  export interface IContext {
    createPlanItemMutation?: TPlanItemCreate
    deletePlanItemMutation?: TPlanItemDelete
    updatePlanTreeMutation?: any
    refetchPlanItems?: () => Promise<any>
    planItems?: IPlanItem[]
  }

  interface IIncomingProps {
    children?: React.ReactNode
    isObjectivesModal?: boolean
  }

  type TPlanItemCreate = MutationFn<NCreatePlanItem.IResponse, NCreatePlanItem.IVariables>
  type TPlanItemDelete = MutationFn<NDeletePlanItem.IResponse, NDeletePlanItem.IVariables>
}

export const MinimizedObjectivesListAPIContext = React.createContext<NObjectivesListAPI.IContext>({})

const MinimizedObjectivesListAPI: React.FunctionComponent<NObjectivesListAPI.IIncomingProps> = ({
  isObjectivesModal,
  children
}) => {
  const router = useRouter()

  const { data: treeQuery, refetch: refetchPlanItems } = useQuery(PARENT_PLAN_SHORT_DETAILS_TREE_QUERY, {
    skip: !router.query.id,
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        planId: router.query.id
      }
    }
  })

  const [createPlanItemMutation] = useMutation(PLAN_ITEM_CREATE_MUTATION)
  const [deletePlanItemMutation] = useMutation(PLAN_ITEM_DELETE_MUTATION)
  const [updatePlanTreeMutation] = useMutation(PLAN_TREE_UPDATE_MUTATION)

  const planItems = get(treeQuery, 'planItems.data')

  const value = {
    createPlanItemMutation,
    deletePlanItemMutation,
    updatePlanTreeMutation,
    refetchPlanItems,
    planItems: isObjectivesModal ? planItems : null
  } as any

  return (
    <MinimizedObjectivesListAPIContext.Provider value={value}>{children}</MinimizedObjectivesListAPIContext.Provider>
  )
}

export default MinimizedObjectivesListAPI
